import { httpCodes } from '@shared/constants/httpCodes'

import BaseHTTPError from './BaseHTTPError'

export default class ForbiddenError<Data> extends BaseHTTPError<Data> {
  constructor(info: { message: string; action: string; data?: Data }) {
    super({
      name: ForbiddenError.name,
      httpCode: httpCodes.FORBIDDEN,
      message: info.message,
      action: info.action,
      data: info?.data
    })
  }
}
